// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title_1kF3w","line":"index_line_3YZ6U","login":"index_login_znHxO","statement":"index_statement_2RzyX"};